import React from "react";

// Components
import { withTranslation } from "react-i18next";
import { MemberInterface, RegistrationStage } from "../../types";
import TableSort from "../Tables/TableSort";
import MembersTableRow from "./MembersTableRow";

type Props = {
  t: any;
  members: MemberInterface[];
  registrationStages: RegistrationStage[];
  handleSort: (key: string, direction: any) => void;
};

class MembersTable extends React.Component<Props, any> {
  render() {
    const { members, t, ...rowProps } = this.props;

    return (
      <div className="members-table__scrollx">
        <table className="members-table">
          <thead>
            <tr>
              <th className="members-table__heading-profile-image ion-text-center">Image</th>
              <th className="members-table__athlete-name">
                {t("name")} <TableSort by="nickname" onSort={this.props.handleSort} />
              </th>
              <th className="members-table__athlete-status">
                {t("status")} <TableSort by="registration_stage_id" onSort={this.props.handleSort} />
              </th>
              <th className="members-table__athlete-last-active">
                {t("lastActive")} <TableSort by="updated_at" onSort={this.props.handleSort} />
              </th>
              <th className="members-table__athlete-notes"></th>
            </tr>
          </thead>
          <tbody>
            {members.length ? (
              members.map((member: MemberInterface, key: number) => <MembersTableRow key={key} member={member} {...rowProps} />)
            ) : (
              <tr>
                <td colSpan={100} align="center">
                  {t("userSearchError")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withTranslation()(MembersTable);
